import cookie from 'react-cookie';
import { p13nServiceDecisions } from '../helpers/ApplicationHelper';
export const PRE_SHIPMENT_UI = Symbol('PRE_SHIPMENT_UI');
export const EMPTY_ACTION = Symbol('EMPTY_ACTION');
export const PRE_REG_ITEM_SCORE = 'preReg_item_score';

// When we're forwarding a user to `/item/<item-id>` path we'd like to know what component
// shall we show to the user. Meantime it's
export function preShipmentUi(itemProperties = {}, user = {}) {
    return {
        type: PRE_SHIPMENT_UI,
        payload: new Promise((resolve, _) => {resolve({data:{preShipmentUi: p13nServiceDecisions.lightListingDraft}})})
    };
}

export function getSessionData() {
    return cookie.load('__utmsession') || {};
}

export function getGA() {
    return (window.ga &&
    typeof (window.ga.getAll) === "function" &&
    window.ga.getAll() &&
    window.ga.getAll().length &&
    window.ga.getAll()[0]) ? window.ga.getAll()[0].get('clientId') : undefined
}

